/** Canonical public site origin (share links, OG tags in public/index.html must match). */
export const SITE_URL = "https://www.dearestinternet.com";

/** Drop `http://` or `https://` for shorter share/clipboard text; most apps still linkify the host. */
export function withoutHttpUrl(url: string): string {
  return url.replace(/^https?:\/\//i, "");
}
